import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import { updateV2SocketData } from './internal/v2-helper';
import { r230522SocketBunja } from './socket';
import { WsV2TableEvent } from './types';

export type CurrencyDetails = Record<string, CurrencyDetail> | null;

export interface CurrencyDetail {
  usdtRate: string;
}

function updateCurrencyDetails(prev: CurrencyDetails, wsData: WsV2TableEvent<CurrencyDetail>['data']) {
  const currencyDetails = updateV2SocketData(prev || {}, wsData);
  return currencyDetails;
}

const currencyDetailsAtom = atom<CurrencyDetails>(null);
export const currencyDetailsBunja = bunja(() => {
  const { r230522Socket } = bunja.use(r230522SocketBunja);
  const store = bunja.use(JotaiStoreScope);
  let unmounted = false;
  const refCountTable: Record<string, number> = {};

  function updateSubs() {
    const currencies = Object.keys(refCountTable).filter((currency) => refCountTable[currency] > 0);
    r230522Socket.send({ s: { currencies: unmounted ? [] : currencies } });
  }

  function subscribeCurrencies(currencies: string[]) {
    const currenciesSet = new Set(currencies);
    currenciesSet.forEach((currency) => {
      refCountTable[currency] = (refCountTable[currency] || 0) + 1;
    });
    updateSubs();
    return () => {
      currenciesSet.forEach((currency) => {
        refCountTable[currency] = (refCountTable[currency] || 0) - 1;
      });
      updateSubs();
    };
  }

  bunja.effect(() => {
    function handler(event: WsV2TableEvent<CurrencyDetail>) {
      if (!event.data) return;
      store.set(currencyDetailsAtom, (prev) => updateCurrencyDetails(prev, event.data));
    }

    updateSubs();
    r230522Socket.on('connected', updateSubs);
    r230522Socket.on('market/currency-details', handler);

    return () => {
      unmounted = true;
      updateSubs();
      r230522Socket.off('connected', updateSubs);
      r230522Socket.off('market/currency-details', handler);
    };
  });

  return {
    currencyDetailsAtom,
    subscribeCurrencies,
  };
});
currencyDetailsBunja.debugLabel = 'currencyDetailsBunja';
